import React, { useState } from "react";
import { Card, CardContent } from "./card";
import { motion } from "framer-motion";

const Home = () => {
  const [videoPlaying, setVideoPlaying] = useState(false);

  const handlePlayVideo = () => {
    setVideoPlaying(true);
  };
  return (
    <div className="app-container">
      <div className="app-header">
        <div className="header-content">
          <div className="title-container">
            <motion.h1
              className="app-title"
              initial={{ opacity: 0, y: -20 }}
              animate={{ opacity: 1, y: 0 }}
            >
              Welcome to VaidhyaMegha Agentic HealthCare Co-Pilot
            </motion.h1>
            <p className="app-subtitle">
              A generative AI-powered healthcare solution for improved patient outcomes
            </p>
          </div>
        </div>
      </div>


      <div className="content-container">
        <Card>
          <CardContent>
            <h2 className="section-title">Executive Summary</h2>
            <p className="section-text">
            The Agentic Healthcare Co-Pilot, is a SMART on FHIR-powered Generative AI application, Designed for real-time clinical decision support. It seamlessly integrates with MeldRx and other FHIR-based EHR systems, leveraging CDS Hooks.
            </p>
          </CardContent>
        </Card>

        <Card>
          <CardContent>
            <h2 className="section-title">Three-Step Generative AI Process</h2>
            <ul className="feature-list">
              <li><strong>Risk Assessment:</strong> Comprehensive analysis consolidating multiple assessments.</li>
              <li><strong>Validation:</strong> LLM judge pattern ensuring prediction reliability.</li>
              <li><strong>Mitigation Plan:</strong> Actionable plans with clinical interventions and follow-ups.</li>
            </ul>
          </CardContent>
        </Card>

        <Card>
          <CardContent>
            <h2 className="section-title">Provider-Facing Features</h2>
            <ul className="feature-list">
              <li>AI Risk Assessment</li>
              <li>Medication Monitoring</li>
              <li>Readmission Risk & Discharge Plans</li>
              <li>Smart Documentation</li>
              <li>Speech-to-Text Summaries</li>
              <li>AI Chat Assistant</li>
              <li>AI-Powered Clinical Search</li>
            </ul>
          </CardContent>
        </Card>

        <Card>
          <CardContent>
            <h2 className="section-title">Patient-Facing Features</h2>
            <ul className="feature-list">
              <li>Personalized health insights</li>
              <li>Proactive alerts</li>
              <li>Continuous health monitoring</li>
            </ul>
          </CardContent>
        </Card>

        <Card>
          <CardContent>
            <h2 className="section-title">Key Features & Benefits</h2>
            <ul className="feature-list">
              <li>SMART on FHIR Integration</li>
              <li>AI-Powered Predictions</li>
              <li>Real-Time Alerts</li>
              <li>Improved clinical outcomes</li>
              <li>Enhanced interoperability</li>
            </ul>
          </CardContent>
        </Card>
      </div>

      <motion.div 
        className="video-container"
        initial={{ opacity: 0, y: 50 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.5, duration: 0.8 }}
      >
        <h2 className="section-title">Watch Our Demo</h2>
        <div className="video-wrapper">
          {videoPlaying ? (
            <iframe
              src="https://www.youtube.com/embed/pgKfyWfLAqM?autoplay=1"
              title="VaidhyaMegha Agentic HealthCare Demo"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            ></iframe>
          ) : (
            <div className="video-thumbnail" onClick={handlePlayVideo}>
              <div className="thumbnail-gradient"></div>
              <div className="play-button-large">
                <svg width="80" height="80" viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <circle cx="40" cy="40" r="40" fill="white" fillOpacity="0.8" />
                  <path d="M55 40L32 55V25L55 40Z" fill="#1a56db" />
                </svg>
              </div>
              <div className="thumbnail-text">
                <span>VaidhyaMegha Agentic HealthCare</span>
                <span className="thumbnail-duration">Watch Demo (3:45)</span>
              </div>
            </div>
          )}
        </div>
        <p className="section-text" style={{ marginTop: '1.5rem', textAlign: 'center', maxWidth: '90%' }}>
          See how our AI-powered healthcare solution can transform patient care and clinical workflows.
        </p>
      </motion.div>
      
      {/* Spacer to ensure content doesn't get hidden behind fixed footer */}
      <div style={{ height: '2rem' }}></div>
    </div>
  );
};

export default Home;
